import { ErrorBoundaryFallback } from 'components/error-boundary/fallback';
import { appConfig } from 'modules/app-config';
import { getMainAppOptions } from 'modules/app-options';
import { initCountly } from 'modules/countly';
import { initDatadog } from 'modules/datadog';
import { initGoogleTagManager } from 'modules/google-tag-manager';
import { createRoot } from 'react-dom/client';
import { MainScheduler } from 'roots/main';
import { ThemeProvider } from 'theme/theme-provider';
import { MainAppOptions } from 'types';
import { setUserTypeFromUrlToStorage } from 'utils/url';

import { installPolyFills } from '../polyfills';

const render = async (options: MainAppOptions) => {
    const root = createRoot(document.getElementById(options.rootElementId)!);

    try {
        // Installing necessary polyfills should always be the first to execute
        await installPolyFills();

        initCountly();
        initDatadog(appConfig.datadog, options);
        initGoogleTagManager();
        setUserTypeFromUrlToStorage();

        const appOptions = getMainAppOptions(options);
        root.render(<MainScheduler options={appOptions} />);
    } catch (error) {
        root.render(
            <ThemeProvider>
                <ErrorBoundaryFallback
                    error={error as Error}
                    resetErrorBoundary={() => {
                        root.unmount();
                        render(options);
                    }}
                />
            </ThemeProvider>
        );
    }
};

const { version } = appConfig;
console.info(`Scheduler version: ${version} - release date: ${__VMD_RELEASE_DATE__}`);

export { render, version };
